export const ZERO = 0;
export const ONE = 1;
